module.exports = __webpack_public_path__ + "static/media/201IT128.3b7827e6.jpg";